<template>
  <div>
    <vonap-window width="832px" height="540px" :title="title" modal @close="close" v-model="show">
      <page-toolbar>
        <kendo-button icon="add" v-show="!isReadOnly" title="Add" @click="addNew"> </kendo-button>
      </page-toolbar>
      <kendo-grid
        ref="grid"
        :height="'450px'"
        :dataSource="dataSource"
        :editable="!isReadOnly && 'inline'"
        :filterable="true"
        :sortable="true"
        :pageable="true"
        :pageable-always-visible="true"
        :columns="gridColumns"
      >
      </kendo-grid>
    </vonap-window>
  </div>
</template>

<script>
import VonapWindow from '@/components/VonapWindow'
import PageToolbar from '@/components/PageToolbar'

export default {
  props: {
    value: {type: Boolean},
    clientId: {type: Number},
    clientName: {type: String},
    isReadOnly: {type: Boolean, default: true},
  },
  data() {
    return {
      dataSource: new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 10,
        transport: {
          create: {
            type: 'POST',
            url: '/api/report/monthlyReportSendingList/CreateMonthlyReportEmail',
            dataType: 'json',
          },
          read: {
            type: 'GET',
            url: '/api/report/monthlyReportSendingList/ReadMonthlyReportEmail',
            data: () => ({
              clientId: this.clientId,
            }),
            dataType: 'json',
          },
          update: {
            type: 'PUT',
            url: '/api/report/monthlyReportSendingList/UpdateMonthlyReportEmail',
            dataType: 'json',
          },
          destroy: {
            type: 'DELETE',
            url: '/api/report/monthlyReportSendingList/DeleteMonthlyReportEmail',
            dataType: 'json',
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'monthlyReportEmailId',
            fields: {
              monthlyReportEmailId: {type: 'number', defaultValue: 0},
              clientId: {
                type: 'number',
                editable: true,
                defaultValue: () => {
                  return this.clientId
                },
              },
              email: {type: 'string', editable: true},
              firstName: {type: 'string', editable: true},
              lastName: {type: 'string', editable: true},
            },
          },
        },
      }),
    }
  },
  computed: {
    gridColumns() {
      return [
        {
          editable: !this.isReadOnly,
          command: [{name: 'edit'}],
          width: 48,
        },
        {
          field: 'email',
          title: 'Email',
          width: 282,
        },
        {
          field: 'firstName',
          title: 'First Name',
          width: 132,
        },
        {
          field: 'lastName',
          title: 'Last Name',
          width: 132,
        },
        {
          editable: !this.isReadOnly,
          command: [{name: 'destroy'}],
          width: 48,
        },
      ].filter(c => c.editable !== false)
    },
    title() {
      return this.clientName + ' Email List'
    },
    show: {
      get() {
        return this.value
      },
      set() {},
    },
  },
  methods: {
    addNew() {
      const grid = this.$refs.grid.kendoWidget()
      grid.addRow()
    },
    close() {
      this.$emit('input', false)
    },
  },
  components: {
    VonapWindow,
    PageToolbar,
  },
}
</script>
